<template>

	<div class="dashboard">
		<div class="dashboard-container">
			<template v-for="board in config">
				<Contact v-if="board === 'contact' && roles['Admin'] || board === 'contact' && user.privileges.blocks.contact" v-bind:key="board" :markets="markets"></Contact>
				<ExperienceBuilder v-if="board === 'experiencebuilder' && roles['Admin'] || board === 'experiencebuilder' && user.privileges.blocks.genererateShowpadExperience" v-bind:key="board" :markets="markets"></ExperienceBuilder>

				<template v-if="board === 'quicklinks' && roles['Admin'] || board === 'quicklinks' && user.privileges.blocks.quickLinks">
					<template v-if="quickLinks.length > 0">
						<QuickLinks v-for="(linkGroup, index) in quickLinks" :markets="markets" :content="linkGroup" v-bind:key="board + index"></QuickLinks>
					</template>

					<template v-else>
						<QuickLinks :markets="markets" :content="quickLinks" v-bind:key="board"></QuickLinks>
					</template>
				</template>

				<HistoryLog v-if="board === 'log' && roles['Admin'] || board === 'log' && user.privileges.blocks.log" v-bind:key="board" :markets="markets"></HistoryLog>
				<MarketEnvironment v-if="board === 'marketenvironment' && roles['Admin'] || board === 'marketenvironment' && user.privileges.blocks.addNewMarket" v-bind:key="board" :markets="markets"></MarketEnvironment>
				<PushInstanceToMarkets v-if="board === 'pushinstancetomarkets' && roles['Admin'] || board === 'pushinstancetomarkets' && user.privileges.blocks.pushInstanceToMarkets" v-bind:key="board" :markets="markets"></PushInstanceToMarkets>
			</template>
		</div>
	</div>

</template>

<script>

import Shuffle from 'shufflejs'
import xhrModule from '../../modules/xhrModule.js'

export default {
	name: 'dashboardbuilder',
	props: {
		type: String
	},
	components: {
		ExperienceBuilder: () => import('./ExperienceBuilder.vue'),
		Contact: () => import('./Contact.vue'),
		QuickLinks: () => import('./QuickLinks.vue'),
		HistoryLog: () => import('./HistoryLog.vue'),
		MarketEnvironment: () => import('./MarketEnvironment.vue'),
		PushInstanceToMarkets: () => import('./PushInstanceToMarkets.vue')
	},

	data () {
		return {
			config: null,
			project: null,
			markets: null,
			roles: this.$store.state.user.roles,
			user: this.$store.state.user,
			quickLinks: [],
			mainslug: this.getMainSlug()
		}
	},

	created () {
		this.fetchConfig()
		this.fetchMarkets()
		this.fetchQuickLinks()
	},

	updated () {
		this.roles = this.$store.state.user ? this.$store.state.user.roles : null
		this.user = this.$store.state.user

		this.setupLayout()
	},

	beforeDestroy () {
		this.shuffleInstance.destroy()
	},

	methods: {
		fetchConfig () {
			var url = '/_conf/config.json'
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.onload = function () {
				var data = JSON.parse(xhr.responseText)
				if (xhr.readyState === 4 && xhr.status === 200) {
					this.config = data.dashboards[this.type]
				} else {
					console.error(data)
				}
			}.bind(this)
			xhr.send(null)
		},

		fetchMarkets () {
			const url = '/cms/api/instances/pushToMarkets/markets'
			xhrModule.get(url, this.getMarketsCompleteHandler.bind(this))
		},

		getMarketsCompleteHandler (markets) {
			this.markets = markets.data
		},

		fetchQuickLinks () {
			var url = '/cms/api/quickLinks?type=' + this.mainslug
			xhrModule.get(url, this.getQuickLinksCompleteHandler.bind(this))
		},

		getQuickLinksCompleteHandler (data) {
			// sort by entity name
			let entities = Object.values(data.data)

			entities.sort((a, b) => {
				const entityNameA = a.entity.translations[0].value
				const entityNameB = b.entity.translations[0].value

				if (entityNameA < entityNameB) {
					return -1
				}

				if (entityNameA > entityNameB) {
					return 1
				}

				// names must be equal
				return 0
			})

			// group every entity by group name
			let entityGroups = {}
			for (let i = 0; i < entities.length; i++) {
				const group = entities[i].group
				if (!entityGroups[group]) entityGroups[group] = []
				entityGroups[group].push(entities[i])

				if (i === entities.length - 1) {
					// convert each object to an array
					entityGroups = Object.values(entityGroups)

					// sort them by group name and by entity name
					entityGroups.sort((a, b) => {
						const groupNameA = a[0].group || ''
						const groupNameB = b[0].group || ''

						if (groupNameA < groupNameB) {
							return -1
						}

						if (groupNameA > groupNameB) {
							return 1
						}

						// names must be equal
						return 0
					})

					this.quickLinks = entityGroups

					// tell parent dashboard to update layout
					setTimeout(() => this.updateLayout(), 10)
				}
			}
		},

		setupLayout () {
			this.shuffleInstance = new Shuffle(document.querySelector('.dashboard-container'), {
				itemSelector: '.box',
				speed: 0
			})
		},

		updateLayout () {
			this.shuffleInstance.layout()
		},

		getMainSlug () {
			var pathName = window.location.pathname
			return pathName.split('/')[1]
		}
	}
}

</script>
